<template>
  <div class="progress">
    <div class="progress__el">
      <div class="progress__bar">
        <div class="progress__line"></div>
        <div
          class="progress__empty"
          :style="{ width: width }"
        ></div>
        <div class="progress__separators">
          <span
            v-for="i in total + 1"
            :key="i"
          ></span>
        </div>
      </div>
    </div>
    <div class="progress__info">
      <div class="progress__info-item progress__info-item_main">
        <slot name="caption"></slot>
      </div>
      <div class="progress__info-item">
        <div class="text-nowrap">{{value}}{{separator}}{{total}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    value: Number,
    total: Number,
    separator: {
      type: String,
      default: ' из '
    }
  },
  computed: {
    width () {
      return (this.total - this.value) / this.total * 100 + '%'
    }
  }
}
</script>

<style lang="scss">
  .progress {
    background-color: inherit;
    padding-top: 8px;

    &__el {
      background-color: $color-white;
    }

    &__bar {
      border-radius: 2px;
      overflow: hidden;
      position: relative;
      background-color: inherit;
    }

    &__empty {
      background-color: inherit;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      transition: $transition-default width;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: map-get($color-neutral-black, 15);
      }
    }

    &__line {
      background-color: $color-success;
      height: 8px;
      width: 100%;
      position: relative;
      z-index: 1;
    }

    &__separators {
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: -1px;
      right: -1px;
      height: 100%;
      background-color: inherit;

      > span {
        display: block;
        flex: 0 0 1px;
        width: 1px;
        height: 8px;
        background-color: inherit;
        position: relative;
        z-index: 1;
      }
    }

    &__info {
      display: flex;
      align-items: center;
      @include text-xs;
      text-align: left;
      margin: 4px -8px 0;
    }

    &__info-item {
      flex: 0 0 auto;
      padding: 0 8px;

      &_main {
        flex: 1 1 100%;
      }
    }
  }
</style>
